import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
} from "recharts";
import { chartTooltipContentStyle } from "@/lib/chartTheme";

const COLORS = [
  "var(--chart-1)",
  "var(--chart-2)",
  "var(--chart-3)",
  "var(--chart-4)",
  "var(--chart-5)",
];

interface ResourceDistributionChartProps {
  data: { type: string; count: number }[];
}

export function ResourceDistributionChart({
  data,
}: ResourceDistributionChartProps) {
  // Handle undefined or empty data
  if (!data || data.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Resources by Type</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex h-[300px] items-center justify-center text-muted-foreground">
            No resource data available
          </div>
        </CardContent>
      </Card>
    );
  }

  // Calculate total for percentage
  const total = data.reduce((sum, item) => sum + item.count, 0);

  // Enrich data with percentage
  const enrichedData = data.map((item) => ({
    ...item,
    percentage: total > 0 ? Math.round((item.count / total) * 100) : 0,
  }));

  return (
    <Card>
      <CardHeader>
        <CardTitle>Resources by Type</CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={enrichedData}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={({ type, percentage }) => `${type} (${percentage}%)`}
              outerRadius={80}
              fill="var(--chart-1)"
              dataKey="count"
            >
              {enrichedData.map((_, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
            <Tooltip contentStyle={chartTooltipContentStyle} />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
